"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircuitBreakerHook = void 0;
var shared_1 = require("@cian/peperrors/shared");
var circuitBreakerError_1 = require("../../errors/circuitBreakerError");
var parsers_1 = require("../../URI/parsers");
var circuitBreakersStore_1 = require("../circuitBreaker/circuitBreakersStore");
var CircuitBreakerHook = /** @class */ (function () {
    function CircuitBreakerHook(params) {
        this.hash = params.context.hashFunction(params.requestConfig);
        this.requestConfig = params.requestConfig;
        this.circuitBreaker = circuitBreakersStore_1.getCircuitBreaker(this.hash, {
            failureTreshold: params.context.failureTreshold,
            samplingDuration: params.context.samplingDuration,
            minimumSamples: params.context.minimumSamples,
            maximumSamples: params.context.maximumSamples,
            openDuration: params.context.openDuration,
            maxTimeForHalfOpenRequest: params.context.maxTimeForHalfOpenRequest,
        });
    }
    CircuitBreakerHook.prototype.onRequest = function () {
        if (!this.circuitBreaker.canRunTask()) {
            throw new circuitBreakerError_1.CircuitBreakerError(parsers_1.uriToString(this.requestConfig.uri));
        }
    };
    CircuitBreakerHook.prototype.onResponse = function () {
        this.circuitBreaker.recordSuccess();
    };
    CircuitBreakerHook.prototype.onError = function (err) {
        if (err instanceof shared_1.HttpTimeoutError) {
            this.circuitBreaker.recordFailure();
        }
        else if (!(err instanceof circuitBreakerError_1.CircuitBreakerError)) {
            this.circuitBreaker.recordSuccess();
        }
    };
    return CircuitBreakerHook;
}());
exports.CircuitBreakerHook = CircuitBreakerHook;
//# sourceMappingURL=CircuitBreakerHook.js.map